import * as pdfApi from "@/apiv2/pdf";
import * as companySessionSelectors from "@/components/new/CompanySession/company-session.selectors";
import { createAction, createSetterActions } from "@/redux/helpers/action";
import { handleError } from "@/redux/utils/error";
import { STATUS } from "@/utils/constants";

import { MODULE } from "./constants";

export const [
  setIsOpen,
  setInvoiceDate,
  setActiveTab,
  setDisplayMode,
  setLastGeneratedDisplayMode,
  setOneLinerDescription,
  setGroupedLabourLabel,
  setGroupedMaterialsLabel,
  setInvoiceDisplayModeStatus,
] = createSetterActions(MODULE, [
  "isOpen",
  "invoiceDate",
  "activeTab",
  "displayMode",
  "lastGeneratedDisplayMode",
  "oneLinerDescription",
  "groupedLabourLabel",
  "groupedMaterialsLabel",
  "invoiceDisplayModeStatus",
]);

export const reset = createAction(`${MODULE}/RESET`);

export const fetchInvoiceDisplayMode =
  ({ orderUid }) =>
  async (dispatch, getState) => {
    if (!orderUid) {
      return;
    }

    const state = getState();
    dispatch(setInvoiceDisplayModeStatus(STATUS.PENDING));
    try {
      const response = await pdfApi.getInvoiceDisplayMode({
        orderUid,
        invoiceType: "standard",
      })();
      const data = response?.data;
      const invoiceDisplayMode = data?.invoiceDisplayMode;
      if (invoiceDisplayMode) {
        dispatch(setDisplayMode(invoiceDisplayMode));
        if (data?.isPreviouslyGenerated) {
          dispatch(setLastGeneratedDisplayMode(invoiceDisplayMode));
        }
      }
      // When the order has no grouped labels yet (e.g. full_breakdown orders
      // that were never generated in grouped mode), the API returns null for
      // these. Fall back to the company invoicing settings so switching to
      // grouped mode pre-fills the company's configured labels.
      const invoiceSettings = companySessionSelectors.getInvoiceSettings(state);
      const labourLabel = data?.groupedLabourLabel ?? invoiceSettings?.groupedLabourLabel;
      if (labourLabel != null) {
        dispatch(setGroupedLabourLabel(labourLabel));
      }
      const materialsLabel = data?.groupedMaterialsLabel ?? invoiceSettings?.groupedMaterialsLabel;
      if (materialsLabel != null) {
        dispatch(setGroupedMaterialsLabel(materialsLabel));
      }

      if (data?.oneLinerDescription != null) {
        dispatch(setOneLinerDescription(data.oneLinerDescription));
      }
      dispatch(setInvoiceDisplayModeStatus(STATUS.FULFILLED));
    } catch (error) {
      dispatch(setInvoiceDisplayModeStatus(STATUS.REJECTED));
      handleError(error, dispatch);
    }
  };
